
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Shop.css';
import { Link } from "react-router-dom";
import ProductList from './ProductList';
import Cart from './Cart';
import "@fontsource/libre-baskerville";
import brandLogo from "./assets/still_logo_white.png";
import cartStatic from './assets/cart.png';
import cartGif from './assets/cart.gif';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const Shop = ({ products, cart, setCart, addToCart }) => {

  const [isCartOpen, setIsCartOpen] = useState(false);

  const removeFromCart = (product) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item._id === product._id);
      if (existingProduct.quantity === 1) {
        return prevCart.filter((item) => item._id !== product._id);
      }
      return prevCart.map((item) =>
        item._id === product._id ? { ...item, quantity: item.quantity - 1 } : item
      );
    });
  };

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleCheckout = () => {
    alert('Checkout successful!');
    setCart([]);
    setIsCartOpen(false);
  };

  return (
    <>
    <Helmet>
      <title>Shop All | STILL Footwear</title>
      <meta name="description" content="Explore our collection of timeless heels and pumps. Designed for comfort and style for all." />
      <link rel="canonical" href="https://stillshoes.com/shop" />
       <meta name="robots" content="index, follow" />
    </Helmet>
    <div>
      <div className="shop-nav">
        <div className="shop-logo">
          <img src={brandLogo} alt="logo" />
        </div>
        <div>
          <ul className="shop-ul">
            <Link className="navbar" to="/">Home</Link>
            <Link className="navbar" to="/contact">Contact</Link>
            <Link className="navbar" to="/about">About</Link>
            <Link className="cart-header" onClick={openCart}>
              <div className="cart-icon">
                <img src={cartStatic} alt="Cart" className="cart-static" />
                <img src={cartGif} alt="Cart" className="cart-gif" />

                {cartCount > 0 && (
                  <span className="cart-badge">{cartCount}</span>
                )}
              </div>
            </Link>

          </ul>
        </div>
      </div>

      <main>
        <ProductList addToCart={addToCart} products={products} />
      </main>

      <Modal
        isOpen={isCartOpen}
        onRequestClose={closeCart}
        contentLabel="Shopping Cart"
        className="cart-modal"
        overlayClassName="cart-overlay"
      >
        <button onClick={closeCart} className="close-button">Close</button>
        <Cart
          cart={cart}
          setCartItems={setCart}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
        />
      </Modal>

      <footer>
        <p>&copy;2026 SHUSH Footwear LLP. Trading as STILL™. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy-policy" className="meta-link" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <h2> | </h2>
          <a href="/terms-and-conditions-policy" className="meta-link" target="_blank" rel="noopener noreferrer">Terms Of Service</a>
        </div>
      </footer>
    </div>

  </>
  );
};

export default Shop;
